import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Contract, Lane, Spot, Violation } from 'src/app/core/models';

// eslint-disable-next-line no-shadow
enum ViewModes {
  list = 'list',
  mosaic = 'mosaic'
}

@Component({
  selector: 'app-list-panel',
  templateUrl: './list-panel.component.html',
  styleUrls: ['./list-panel.component.sass']
})
export class ListPanelComponent implements OnInit {

  @Input() loadingList = false;
  @Input() connected: boolean;
  @Input() lastData: Violation;
  @Input() violations: Violation[] = [];
  @Input() violationData: Array<{ passId: string; spot: Spot; lane: Lane }> = [];
  @Input() contract: Contract;
  @Output() selectedViolation = new EventEmitter<Violation>();
  @Output() pauseEvent = new EventEmitter<boolean>();
  @Output() closedEvent = new EventEmitter<boolean>();

  public viewModes = ViewModes;
  public viewMode: string = ViewModes.list;
  public paused = false;
  public closed = false;
  public viewFilters = false;

  constructor() { }

  ngOnInit(): void {
    document.addEventListener('openPanel', () => this.closed = false);
    document.addEventListener('openOrCloseFilters', (data: CustomEvent) => this.viewFilters = data.detail.viewFilters);
  }

  setViewMode(value: string) {
    this.viewMode = value;
  }

  selectViolation(violation: Violation) {
    this.selectedViolation.emit(violation);
  }

  pauseOrResume() {
    this.paused = !this.paused;
    this.pauseEvent.emit(this.paused);
  }

  closeOrOpenPanel() {
    this.closed = !this.closed;
    this.closedEvent.emit(this.closed);
  }

  openOrCloseFilters() {
    this.viewFilters = !this.viewFilters;
    const event = new CustomEvent('openOrCloseFilters', { detail: { viewFilters: this.viewFilters } });
    document.dispatchEvent(event);
  }

}
